var render = function render(){var _vm=this,_c=_vm._self._c;return _c('alarms-list-table-with-pagination',_vm._g({attrs:{"parent-alarm":_vm.alarm,"widget":_vm.widget,"alarms":_vm.alarms,"meta":_vm.meta,"query":_vm.query,"columns":_vm.widget.parameters.widgetGroupColumns,"loading":_vm.pending,"refresh-alarms-list":_vm.refreshAlarmsList,"columns-settings":_vm.columnsSettings,"expandable":""}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }